import apiClient from '@/services/api'

export default {
  async getRefBook(_, { name }) {
    try {
      const { data } = await apiClient.get(`/api/refBook/${name}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.items
    } catch (error) {
      throw error.message
    }
  },
  async postRefBook(_, { refBook, ...rest }) {
    try {
      const { data } = await apiClient.post(`/api/refBook/${refBook}`, {
        ...rest
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.item
    } catch (error) {
      throw error.message
    }
  }
}
